export class ProdutoTabelaEspecial {
  public idprodutotabelaespecial: number;
  public descricao: string;
  public dtcriacao: Date;
  public guidclientenapis: string;
  public ativo: boolean;
  public cd_tabela_cliente: number;
  public filtro_tabela: string;
  public id_prazostr: string;
  public flag_desativar_na_integracao: string;
  public cod_tabela_ecommerce: number;
  public dt_inicio: Date;
  public dt_fim: Date;
  public flag_naoaplicafatorpontuacaofin: boolean;

  constructor() { }
}
